import { Col, Form, Input, Row } from "antd";
import React, { useEffect } from "react";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import NetwalaButton from "../Items/Button/Index";
import NetwalaModal from "../Items/Modal/Index";
import "./styles/RequestIPTVModal.css";
const UpdateConnectionOntIDModal: React.FC<
  UpdateOntIDModalForConnectionModalProp
> = ({ show, handleClose, ontID, intPkConnectionID }) => {
  const { openNotification, contextHolder } = useMultiNotification();

  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<UpdateOntIDOfConnectionApiProp>(
    "connections/updateOntIDOnConnection",
    true
  );

  const onFinish = (values: any) => {
    const { ontID } = values;
    const dataToSend: UpdateOntIDOfConnectionApiProp = {
      intPkConnectionID,
      ontID,
    };
    postApiData(dataToSend);
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);
  const onFinishFailed = (errorInfo: any) => {};
  return (
    <>
      <NetwalaModal
        title="Update Ont ID"
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          handleClose(false);
        }}
      >
        {contextHolder}
        <Row>
          <Col span={24} className="iptv-modal-package-details">
            <Form
              requiredMark={false}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="updateOntIDOfConnectionForm"
              initialValues={{
                ontID: ontID !== null ? ontID : "",
              }}
            >
              <Form.Item
                label={<span className="create-user-form-label">Ont ID</span>}
                name="ontID"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Ont ID",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="ACFD20202020202"
                />
              </Form.Item>

              <Form.Item>
                <NetwalaButton
                  backgroundColor={ButtonProps.background.YELLOW}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Submit"
                  borderColor="#FFA726"
                  disabled={apiLoading}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </NetwalaModal>
    </>
  );
};

export default UpdateConnectionOntIDModal;
